// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"317":"4f033b96","534":"f1b9c115","975":"d8990242"}[chunkId] + ".chunk.css";
};